export type GlobalSearchResult = {
  id: string
  kind: 'productionOrder' | 'article' | 'resource' | 'workCenter' |
    'productionUnit' | 'calendar' | 'warehouse' | 'maintenanceAsset' |
    'maintenancePlan' | 'maintenanceOrder'
  title: string
  description: string
  route: string
}

export async function globalSearch(query: string, signal: AbortSignal) {
  const response = await apiFetch(`/api/v1/search?q=${encodeURIComponent(query)}`, {
    credentials: 'include',
    signal,
  })
  if (!response.ok) throw new Error('nav.searchError')
  return response.json() as Promise<GlobalSearchResult[]>
}
import { apiFetch } from '../../shared/http/apiFetch'
